<template>
  <div>
    <div
      class="goodsManageSet"
      :class="{ fixedStyle: isShowStyle }"
      :style="{ top: scrollTop + 'px' }"
    >
      <div class="banner">
        <img src="../../../assets/images/banner1.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div>
        <div class="breadcrumb_item">SKU管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">商品管理</div>
      </div>

      <div class="main_content">
        <div class="tit">其它设置</div>
        <div class="block">
          <h1>是否设置为精品推荐</h1>
          <div class="radio_box">
            <van-radio-group direction="horizontal" v-model="formData.isintro">
              <van-radio name="是">是</van-radio>
              <van-radio name="否">否</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="block">
          <h1>是否设置为置顶</h1>
          <div class="radio_box">
            <van-radio-group direction="horizontal" v-model="formData.istop">
              <van-radio :name="1">是</van-radio>
              <van-radio :name="0">否</van-radio>
            </van-radio-group>
          </div>
        </div>

        <!-- <div class="block">
          <h1>排序设置</h1>
          <p class="red" style="margin-bottom: 0.25rem">
            排序管理由数字序号控制，请输入数字为商品的排序编号
          </p>
          <div class="input_box">
            <van-field
              v-model="formData.sort"
              type="number"
              placeholder="请输入排序数字"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="10"
            />
          </div>
        </div> -->

        <div class="block">
          <h1>是否设置为预售</h1>
          <div class="radio_box">
            <van-radio-group v-model="formData.ispre">
              <van-radio :name="true">
                <div class="flex-rowl limit_content">
                  是<van-field
                    v-model="formData.predate"
                    placeholder="请设置正式预售日期"
                    readonly
                    @click="handleClickShowDate"
                    class="van_input"
                  />
                </div>
              </van-radio>
              <van-radio :name="false">否</van-radio>
            </van-radio-group>
          </div>
        </div>

        <div class="block">
          <h1>前端购买人数显示管理</h1>
          <div class="radio_box">
            <van-radio-group v-model="formData.numtype">
              <van-radio name="显示真实成交数" @click="formData.numview = ''"
                >显示真实成交数</van-radio
              >
              <van-radio name="显示静态数字" @click="formData.numview = 0">
                <div class="flex-rowl limit_content">
                  显示静态数字
                  <van-field
                    v-model="formData.numview"
                    type="number"
                    placeholder="请输入购买人数"
                    maxlength="6"
                    class="van_input"
                  />
                </div>
              </van-radio>
            </van-radio-group>
          </div>
        </div>

        <div class="block">
          <h1>设置关联商品</h1>
          <p class="red" style="margin-bottom: 0.25rem">
            输入已知商品ID，最多关联6件
          </p>
          <div class="input_box">
            <van-field
              v-model="formData.cmid1"
              type="number"
              placeholder="请输入管理商品ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="15"
            />
          </div>
          <div class="input_box">
            <van-field
              v-model="formData.cmid2"
              type="number"
              placeholder="请输入管理商品ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="15"
            />
          </div>
          <div class="input_box">
            <van-field
              v-model="formData.cmid3"
              type="number"
              placeholder="请输入管理商品ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="15"
            />
          </div>
          <div class="input_box">
            <van-field
              v-model="formData.cmid4"
              type="number"
              placeholder="请输入管理商品ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="15"
            />
          </div>
          <div class="input_box">
            <van-field
              v-model="formData.cmid5"
              type="number"
              placeholder="请输入管理商品ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="15"
            />
          </div>
          <div class="input_box">
            <van-field
              v-model="formData.cmid6"
              type="number"
              placeholder="请输入管理商品ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="15"
            />
          </div>
        </div>

        <div class="block">
          <h1>物流包装规格（每个物流包）数字</h1>
          <div class="input_box">
            <van-field
              v-model="formData.spec"
              type="number"
              placeholder="请输入物流包装规格（每个物流包）数字"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="15"
            />
          </div>

          <h1>单位规格类型</h1>
          <div class="radio_box">
            <van-radio-group direction="horizontal" v-model="formData.spec_ext">
              <van-radio name="件" style="margin-bottom: 10px">件</van-radio>
              <van-radio name="本" style="margin-bottom: 10px">本</van-radio>
              <van-radio name="个" style="margin-bottom: 10px">个</van-radio>
              <van-radio name="只" style="margin-bottom: 10px">只</van-radio>
              <van-radio name="套" style="margin-bottom: 10px">套</van-radio>
              <van-radio name="包" style="margin-bottom: 10px">包</van-radio>
              <van-radio name="克" style="margin-bottom: 10px">克</van-radio>
              <van-radio name="千克（公斤）" style="margin-bottom: 10px">千克（公斤）</van-radio>
              <van-radio name="毫升" style="margin-bottom: 10px">毫升</van-radio>
              <van-radio name="升" style="margin-bottom: 10px">升</van-radio>
            </van-radio-group>
          </div>
        </div>

        <div class="block" v-if="false">
          <h1>设置关联盲盒</h1>
          <p class="red" style="margin-bottom: 0.25rem">
            输入已知盲盒ID，最多关联6件
          </p>
          <div class="input_box">
            <van-field
              v-model="formData.boxid1"
              type="number"
              placeholder="请输入关联盲盒ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="10"
            />
          </div>
          <div class="input_box">
            <van-field
              v-model="formData.boxid2"
              type="number"
              placeholder="请输入关联盲盒ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="10"
            />
          </div>
          <div class="input_box">
            <van-field
              v-model="formData.boxid3"
              type="number"
              placeholder="请输入关联盲盒ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="10"
            />
          </div>
          <div class="input_box">
            <van-field
              v-model="formData.boxid4"
              type="number"
              placeholder="请输入关联盲盒ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="10"
            />
          </div>
          <div class="input_box">
            <van-field
              v-model="formData.boxid5"
              type="number"
              placeholder="请输入关联盲盒ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="10"
            />
          </div>
          <div class="input_box">
            <van-field
              v-model="formData.boxid6"
              type="number"
              placeholder="请输入关联盲盒ID"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="10"
            />
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>

    <van-calendar v-model="isShow" @confirm="onConfirm" />
  </div>
</template>

<script>
import {
  getCommidityDetail,
  editCommidity,
  encryptstringview,
} from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "cOthers",
  data() {
    return {
      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      isShowType: 1,
      isShow: false,

      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        isintro: "", // 是否精品推荐商品 = 是 否
        istop: "", // 是否置顶 = 1置顶 0 不置顶
        numtype: "", // 前端购买人数<br>显示管理 = 真实购买人数 静态购买人数
        numview: "", // 前端商品已销数量静态显示设置
        ispre: "", // 是否预售
        predate: "", // 开售日期
        cmid1: "", // 关联推荐商品1的id
        cmid2: "", // 关联推荐商品2的id
        cmid3: "", // 关联推荐商品3的id
        cmid4: "", // 关联推荐商品4的id
        cmid5: "", // 关联推荐商品5的id
        cmid6: "", // 关联推荐商品6的id
        spec: '',  //  物流包装规格（每个物流包）数字
        spec_ext: ''  // 件 本 个 只 套 包 克 千克（公斤） 毫升 升
        // boxid1: "", // 关联盲盒id1
        // boxid2: "", // 关联盲盒id2
        // boxid3: "", // 关联盲盒id3
        // boxid4: "", // 关联盲盒id4
        // boxid5: "", // 关联盲盒id5
        // boxid6: "", // 关联盲盒id6
      },
      cmid: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.cmid = id;
        this.getDetail();
      } else {
        this.$router.back();
      }
    },

    getDetail() {
      let { cmid } = this;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getCommidityDetail({ id: cmid }).then((res) => {
        this.formData.id = res.id ? res.id : "";
        this.formData.isintro = res.iisintrod ? res.isintro : "否";
        this.formData.istop = res.istop ? res.istop : 0;
        this.formData.ispre = res.ispre ? res.ispre : false;
        this.formData.predate = res.predate ? res.predate : "";
        this.formData.numtype = res.numtype ? res.numtype : "";
        this.formData.numview = res.numview ? res.numview : "";
        this.formData.cmid1 = res.cmid1 ? res.cmid1 : "";
        this.formData.cmid2 = res.cmid2 ? res.cmid2 : "";
        this.formData.cmid3 = res.cmid3 ? res.cmid3 : "";
        this.formData.cmid4 = res.cmid4 ? res.cmid4 : "";
        this.formData.cmid5 = res.cmid5 ? res.cmid5 : "";
        this.formData.cmid6 = res.cmid6 ? res.cmid6 : "";
        this.formData.spec = res.spec ? res.spec : "";
        this.formData.spec_ext = res.spec_ext ? res.spec_ext : "";
        // this.formData.boxid1 = res.boxid1 ? res.boxid1 : "";
        // this.formData.boxid2 = res.boxid2 ? res.boxid2 : "";
        // this.formData.boxid3 = res.boxid3 ? res.boxid3 : "";
        // this.formData.boxid4 = res.boxid4 ? res.boxid4 : "";
        // this.formData.boxid5 = res.boxid5 ? res.boxid5 : "";
        // this.formData.boxid6 = res.boxid6 ? res.boxid6 : "";

        Toast.clear();
      });
    },
    handleClickPreOne() {
      this.formData.predate = "";
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },
    handleNavBar(id) {
      if (id == 1) {
        window.location.replace("default.html");
      } else {
        this.$toast("即将开放");
      }
    },
    handleReturn() {
      history.back();
    },

    // 显示弹窗
    handleShowpopup(type) {
      if (type == 1) {
        this.isShowType = 1;
      } else if (type == 2) {
        this.isShowType = 2;
      }
      this.isShow = true;
    },
    handleClickShowDate() {
      let { ispre } = this.formData;
      if (!ispre) {
        this.$toast("暂不设置预售时间");
        return;
      }
      this.isShow = true;
    },
    onConfirm(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.formData.predate = year + "/" + month + "/" + date;
      this.isShow = false;
    },

    query() {
      let { formData } = this;
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editCommidity(formData).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(data.message);
          }, 500);
          // setTimeout(() => {
          //   history.back();
          // }, 1500);
        } else {
          this.$toast.fail(data.message || "服务器报错，请稍后～");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      .input_box {
        margin-bottom: 30px;
      }
      .limit_content {
        white-space: nowrap;
        .van_input {
          border: 1px solid #adadadc2;
          margin-left: 30px;
          border-radius: 45px;
          padding: 6px 10px;
        }
      }
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
}
</style>